export default __webpack_public_path__ + "static/media/made-asy-bg.2c38595c.svg";